export default "__VITE_ASSET__CirGoI8c__"